import { Component } from '@angular/core'
import { IonicPage, LoadingController, NavController, NavParams, ToastController } from 'ionic-angular'

import { AuthProvider } from '../../providers/auth/auth'
import { UserProvider } from '../../providers/user/user'
import { ControlPanelPage } from '../control-panel/control-panel'
import { HousingUnitEditPage } from '../../pages/housing-unit-edit/housing-unit-edit'

import { User } from '../../models/models'

@IonicPage()
@Component({
	selector: 'page-user-edit',
	templateUrl: 'user-edit.html',
})
export class UserEditPage {
	public user: User
	public loading: any

	constructor(
		public auth: AuthProvider,
		public loadingCtrl: LoadingController,
		public navCtrl: NavController,
		public navParams: NavParams,
		public toastCtrl: ToastController,
		public users: UserProvider
	) {
		this.user = navParams.get('user')
	}

	public goToControlPanel() {
		this.navCtrl.setRoot(ControlPanelPage)
	}
	public save() {
		console.log("Si sta salvando l'utente:", this.user)
		if(!this.user) {//nessun utente selezionato
			console.log('Nessun utente selezionato')
			let toast = this.toastCtrl.create({
				message: 'Nessun utente aggiunto',
				position: 'middle',
				duration: 3000,
				cssClass: "light"
			})
			toast.present()
			this.navCtrl.pop()
		}

		/*
		Dati utente per il feedback
		*/
		let label = null
		if(this.user.type == 'person') {
			label = 'Persona'
		} else if(this.user.type == 'company') {
			label = 'Azienda'
		} else {
			label = 'Utente di tipo sconosciuto'
		}

		//let titles = '';
		if(this.user.is_admin) {
			label += ' sviluppatore'
		}
		if(this.user.is_administrator) {
			label += ' amministratore'
		}
		if(this.user.is_heatingreader) {
			label += ' termoletturista'
		}
		if(this.user.is_operator) {
			label += ' gestore'
		}
		if(this.user.is_worker) {
			label += ' addetto'
		}

		label += '"' + this.user.name ? this.user.name : ''
		if(this.user.surname) {
			label += ' ' + this.user.surname
		}
		label += '"'

		let self = this
		this.loading = this.loadingCtrl.create({
			content: 'Salvataggio in corso...',
			dismissOnPageChange: false
		})
		this.loading.present()

		this.users.update(this.user).then(user => {
			self.loading.dismiss()
			let toast = this.toastCtrl.create({
				message: "Salvato " + label,
				position: 'middle',
				duration: 3000,
				cssClass: "light"
			})
			toast.present()
			self.navCtrl.pop()
		}).catch((error: any) => {
			self.loading.dismiss()
			let toast = this.toastCtrl.create({
				message: "Errore salvando l'utente " + label,
				position: 'middle',
				duration: 3000,
				cssClass: "danger"
			})
			toast.present()
			self.navCtrl.pop()
		})
	}

	public goToHousingUnitEdit(unit) {
		this.navCtrl.push(HousingUnitEditPage, { housingUnit: unit })
	}

	public get isFiscalIdentifierReadonly(): boolean {
		return !this.auth.canUserEditFiscalIdentifier(this.user)
	}
	/*
	ionViewDidLoad() {
		console.log('ionViewDidLoad UserEditPage');
	}
	*/
}



// WEBPACK FOOTER //
// ./src/pages/user-edit/user-edit.ts